import { render } from "./snowalert.vue?vue&type=template&id=4cd2c2ce"
import script from "./snowalert.vue?vue&type=script&lang=js"
export * from "./snowalert.vue?vue&type=script&lang=js"

import "./snowalert.vue?vue&type=style&index=0&id=4cd2c2ce&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__